<template>
  <v-row justify="center">
    <v-dialog v-model="AdminConfirmDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"> Warning .... </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="9" class="pt-0 pb-0">
              You are giving this user absolute privileges in the control panel
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <span class="warningClass group pa-2">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="closeDialogAccept(false)">
            I don't want
          </v-btn>
          <v-btn color="green darken-1" text @click="closeDialogAccept(true)">
            I Know
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<style >
.warningClass {
  font-size: 35px;
  color: orange;
  float: right;
}
</style>
<script>
export default {
  props: ["AdminConfirmDialog"],
  data() {
    return {};
  },
  methods: {

      closeDialogAccept(AcceptVal = false){
          this.$emit("closeAdminConfirmDialog" , AcceptVal);
      },
  },
};
</script>